import { createApi, fetchBaseQuery,  } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";


// RTLK Query API for ShortLink
export const shortLinkApi = createApi({
  reducerPath: "shortLinkApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  // baseQuery: dynamicBaseQuery,
  tagTypes: ["ShortLink"],
  endpoints: (builder) => ({
    getshortLink: builder.query({
      query: () => ({
        url: `/short-link/get-all-short-link`,
        method: "GET",
      }),
      invalidatesTags: ["ShortLink"],
    }),
    updateshortLunk: builder.mutation({
      query: (data) => ({
        url: `/short-link/update-short-link`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["ShortLink"],
    }),
    deleteshortLink: builder.mutation({
      query: (data) => ({
        url: `/short-link/delete-short-link`,
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["ShortLink"],
    }),
    createnewShortLink: builder.mutation({
      query: (data) => ({
        url: "/short-link/create-short-link",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ShortLink"],
    }),
    previewshortLink: builder.query({
      query: () => ({
        url: "/short-link/redirect/:shortlink",
        method: "GET",
      }),
      providesTags: ["ShortLink"],
    }),
    getHeaders: builder.query({
      query: () => ({
        url: "/short-link/get-all-headers",
        method: "GET",
      }),
      providesTags: ["ShortLink"],
    }),
  }),
});
export const {
  useGetshortLinkQuery,
  useUpdateshortLunkMutation,
  useDeleteshortLinkMutation,
  useCreatenewShortLinkMutation,
  usePreviewshortLinkQuery,
  useGetHeadersQuery,
} = shortLinkApi;
